export const GIT = {
  GIT_REPO_NAME: 'react-play',
  GIT_REPO_USER: 'reactplay'
};
